var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useEffect } from 'react';
import 'tippy.js/dist/tippy.css';
import * as S from './styles';

var Tooltip = function Tooltip(_a) {
  var children = _a.children,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'default' : _a$variant,
      _a$theme = _a.theme,
      theme = _a$theme === void 0 ? 'light-border' : _a$theme,
      rest = __rest(_a, ["children", "variant", "theme"]);

  var isDefaultTheme = ['light', 'light-border', 'material', 'translucent'].includes(theme);
  useEffect(function () {
    if (isDefaultTheme) {
      require("tippy.js/themes/".concat(theme, ".css"));
    }
  });
  return React.createElement(S.StyledTippy, Object.assign({}, rest, {
    variant: variant,
    theme: theme
  }), children);
};

export { Tooltip };